/* Product page helpers (conversion pass 2026-10-01):
   1. Choose a size first: when a product has a Size option, no size starts selected and Add to cart
      reads "Choose a size" until one is picked (stops accidental XS orders).
   2. Size guide link next to the sizes, opening the size table from the description in a pop-up.
   3. Description tidy: the first paragraph stays; the rest folds into tap-to-open sections.
   4. Sold-out sizes show an "Email me when it's back" form. */
(function () {
  var info = document.querySelector('product-info'); if (!info) return;
  var chosen = false;
  function sizeSet() {
    return [...info.querySelectorAll('fieldset.product-form__input')].find(function (f) {
      var l = f.querySelector('legend'); return l && /^\s*size/i.test(l.textContent);
    });
  }
  function btn() { return info.querySelector('button[name="add"]'); }
  function lock() {
    var f = sizeSet(); if (!f || chosen) return;
    if (f.querySelectorAll('input[type="radio"]').length < 2) { chosen = true; return; }
    f.querySelectorAll('input[type="radio"]').forEach(function (i) { i.checked = false; });
    f.classList.add('mm-needs-size');
    var b = btn(); if (!b) return;
    b.setAttribute('disabled', ''); b.dataset.mmLocked = '1';
    var s = b.querySelector('span'); if (s) s.textContent = 'Choose a size';
  }
  function picked(e) {
    var inp = e.target.closest && e.target.closest('input[type="radio"]');
    if (!inp) return;
    var fs = inp.closest('fieldset'), l = fs && fs.querySelector('legend');
    if (l && /^\s*size/i.test(l.textContent)) {
      chosen = true; fs.classList.remove('mm-needs-size');
      var b = btn(); if (b) { delete b.dataset.mmLocked; var sp = b.querySelector('span'); if (sp && /choose a size/i.test(sp.textContent)) sp.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'; }
    }
  }
  document.addEventListener('change', picked, true);
  document.addEventListener('click', function (e) { var lab = e.target.closest && e.target.closest('label[for]'); if (lab) { var i = document.getElementById(lab.getAttribute('for')); if (i) picked({ target: i }); } }, true);
  document.addEventListener('submit', function (e) {
    if (!chosen && sizeSet() && e.target.closest('product-form')) { e.preventDefault(); e.stopImmediatePropagation(); var f = sizeSet(); f.scrollIntoView({ block: 'center', behavior: 'smooth' }); f.classList.add('mm-shake'); setTimeout(function () { f.classList.remove('mm-shake'); }, 600); }
  }, true);
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { lock(); guide(); notify(); }, 60); }).observe(info, { childList: true, subtree: true });

  // 2. Size guide
  var desc = info.querySelector('.product__description');
  var table = desc && desc.querySelector('table');
  var dlg;
  function guide() {
    var f = sizeSet(); if (!f || !table || f.querySelector('.mm-sizeguide-link')) return;
    var a = document.createElement('button'); a.type = 'button'; a.className = 'mm-sizeguide-link'; a.textContent = 'Size guide';
    a.addEventListener('click', function () {
      if (!dlg) {
        dlg = document.createElement('dialog'); dlg.className = 'mm-pre-dialog mm-sizeguide';
        dlg.innerHTML = '<button type="button" class="mm-pre-dialog__x" aria-label="Close">&times;</button><div class="mm-pre"><h2 class="mm-pre__title">Size guide</h2><div class="mm-sizeguide__t"></div><p style="margin:0;font-size:14px">Measurements in inches. Between sizes? Size up for a relaxed fit.</p></div>';
        dlg.querySelector('.mm-sizeguide__t').appendChild(table.cloneNode(true));
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('.mm-pre-dialog__x')) dlg.close(); });
        document.body.appendChild(dlg);
      }
      dlg.showModal();
    });
    f.querySelector('legend').appendChild(a);
  }

  // 3. Description tidy (content stays in the page for search engines)
  if (desc && !desc.dataset.mmTidy) {
    desc.dataset.mmTidy = '1';
    var kids = [...desc.children]; if (kids.length > 2) {
      var first = kids[0];
      var groups = { details: [], size: [], safety: [] };
      kids.slice(1).forEach(function (k) {
        var txt = k.textContent || '';
        if (k.tagName === 'TABLE' || k.querySelector('table') || /^\s*size guide\s*$/i.test(txt)) groups.size.push(k);
        else if (/General Product Safety|GPSR|EU representative/i.test(txt)) groups.safety.push(k);
        else groups.details.push(k);
      });
      function fold(title, nodes, open) {
        if (!nodes.length) return;
        var d = document.createElement('details'); d.className = 'mm-fold'; if (open) d.open = true;
        d.innerHTML = '<summary>' + title + '</summary><div class="mm-fold__b"></div>';
        var b = d.querySelector('.mm-fold__b'); nodes.forEach(function (n) { b.appendChild(n); });
        desc.appendChild(d);
      }
      fold('Details', groups.details); fold('Size chart', groups.size); fold('Product safety (EU)', groups.safety);
      void first;
    }
  }

  // 4. Back in stock
  var nf = document.querySelector('[data-mm-notify]');
  function notify() {
    if (!nf) return; var b = btn(); if (!b) return;
    var sold = b.hasAttribute('disabled') && !b.dataset.mmLocked;
    nf.hidden = !sold;
    if (sold) {
      var v = info.querySelector('variant-selects [data-selected-variant]');
      var label = [...info.querySelectorAll('fieldset input:checked')].map(function (i) { return i.value; }).join(' / ');
      var f = nf.querySelector('[name="contact[body]"]'); if (f) f.value = 'Back-in-stock request: ' + document.title.split('|')[0].trim() + (label ? ' (' + label + ')' : '') + ' ' + location.href;
    }
  }
  lock(); guide(); notify();
})();
